import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { render_field } from '../../../../utils/renderField';
import renderDropZoneField from '../../../form/DropZone';
class ProfileSettings extends PureComponent {

  constructor(props, context) {
    super(props, context);
    this.state = {
      name: 'Lora Kolly',
      email: 'lkolly@yourcompany.com',
      textarea: 'Hello world!',
      countries: [],
      regions: [],
      cities: [],
      currentCountry: {},
      currentRegion: {},
      currentCity: {},
      street: ''
    };

    this.key = 'f1469bac628eeb013b607723b5d78c55'
    this.apiUser = 'shawkhail'

    this.initCountries = this.initCountries.bind(this)
    this.onButtutaCountryChange = this.onButtutaCountryChange.bind(this)
    this.onButtutaRegionChange = this.onButtutaRegionChange.bind(this)
    this.onButtutaCityChange = this.onButtutaCityChange.bind(this)
  }

  async componentDidMount () {
    this.initCountries()
  }

  async componentDidUpdate (prevProps, prevState) {
    if (prevState.currentCountry !== this.state.currentCountry) {

      this.onButtutaCountryChange(this.state.currentCountry.geonameId)
    }

    if (prevState.currentRegion !== this.state.currentRegion) {
      this.onButtutaRegionChange(this.state.currentRegion.geonameId)
    }

  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  async initCountries () {
    let Countries = null;
    const url = `http://api.geonames.org/countryInfoJSON?username=${this.apiUser}`
    await window.$.getJSON(url, function (countries) {
      Countries = countries.geonames
    })

    this.setState({
      countries: Countries,
      currentCountry: Countries[0]
    })
  }

  async onButtutaCountryChange (event) {
    let eValue;
    if (event === 'undefined' || event === undefined) {
      return;
    } else if (event.target === 'undefined' || event.target === undefined) {
      eValue = event
    } else {
      window.$.each(this.state.countries, function (key, country) {
        return country.countryName === event.target.value ? eValue = country.geonameId : null
      })
    }
    const url = `http://api.geonames.org/childrenJSON?geonameId=${eValue}&username=${this.apiUser}&hierarchy=geography`

    let Regions, cRegion, cCountry;
    await window.$.getJSON(url, function (regions) {
      regions.geonames ? Regions = regions.geonames : Regions = []
      Regions.length ? cRegion = Regions[0] : cRegion = {}
    })

    window.$.each(this.state.countries, function (key, country) {
      return country.geonameId === eValue ? cCountry = country : null
    })
    this.setState({
      regions: Regions,
      currentRegion: cRegion,
      currentCountry: cCountry
    })
  }

  async onButtutaRegionChange (event) {
    let eValue;
    if (event === 'undefined' || event === undefined) {
      this.setState({
        cities: [],
        currentCity: {}
      })
      return;
    } else if (event.target === 'undefined' || event.target === undefined) {
      eValue = event
    } else {
      window.$.each(this.state.regions, function (key, region) {
        return region.name === event.target.value ? eValue = region.geonameId : null
      })
    }
    const url = `http://api.geonames.org/childrenJSON?geonameId=${eValue}&username=${this.apiUser}&hierarchy=geography`
    let Cities, cCity, cRegion;
    await window.$.getJSON(url, function (cities) {
      cities.geonames ? Cities = cities.geonames : Cities = {}
      Cities.length > 1 ? cCity = Cities[0] : cCity = {}
    })

    window.$.each(this.state.regions, function (key, region) {
      return region.geonameId === eValue ? cRegion = region : null
    })
    this.setState({
      cities: Cities,
      currentCity: cCity,
      currentRegion: cRegion,
    })
  }

  onButtutaCityChange (event) {
    let cCity;
    window.$.each(this.state.cities, function (key, city) {
      return city.name === event.target.value ? cCity = city : null
    })

    this.setState({
      currentCity: cCity
    })
  }

  onStreetChange = street => event => {
    this.setState({
      [street]: event.target.value
    })
  }

  render () {
    const { handleSubmit } = this.props;
    return (
      <form className='form__profile-settings' onSubmit={handleSubmit}>
        <div>
          <div className='form__form-group-field upload-photo-field'>
            <Field
              name='file'
              component={renderDropZoneField}
              type='text'
              placeholder='Default Input'
            />
          </div>
          <div id='photoUpload'>
            <label>Upload Photo</label>
          </div>
          <div className='form__form-group-field'>
            <Field
              id='username'
              name='username'
              component={render_field}
              type='text'
              placeholder={`${this.props.user.given_name} ${this.props.user.family_name} `}
              onChange={this.handleChange('name')}

            />
          </div>
          <div className='form__form-group-field'>
            <Field
              id='email'
              name='email'
              component={render_field}
              type='email'
              placeholder={this.props.user.email}
              defaultValue={this.state.email}
              onChange={this.handleChange('name')}

            />
          </div>
          {/* <div className='form__form-group-field'>
            <Field
              id='country'
              name="country"
              component={renderCountrySelect}
              type='select'
              label={this.state.countries ? this.state.countries : null}
              //defaultValue = {this.state.countries ? this.state.countries : null}
              placeholder="Country"
              defaultValue={this.state.currentCountry ? this.state.currentCountry.countryName : 'No Country'}
              onChange={this.onButtutaCountryChange}
              
            />
          </div>
          <div className='form__form-group-field'>
            <Field
              id='region'
              name="region"
              component={renderRegionSelect}
              onChange={this.onButtutaRegionChange}
              label={this.state.regions ? this.state.regions : null}
              //defaultValue = {this.state.countries ? this.state.countries : null}
              placeholder='Region'
              defaultValue={this.state.currentRegion ? this.state.currentRegion.name : 'No Region'}
              type='select'
            />
          </div>
          <div className='form__form-group-field'>
            <Field
              id='city'
              name="city"
              component={renderCitySelect}
              onChange={this.onButtutaCityChange}
              label={this.state.cities ? this.state.cities : null}
              //defaultValue = {this.state.countries ? this.state.countries : null}
              placeholder= 'City'
              defaultValue={this.state.currentCity ? this.state.currentCity.name : 'No City'}
              type='select'
            />
          </div>

          <div className='form__form-group-field'>
            <Field
              id='street'
              name='street'
              component={render_field}
              placeholder='Street'
              defaultValue={this.state.street}
              onChange={this.onStreetChange('street')}
              type='text'
            />
          </div> */}
          {/* <div>
          <label className='material-form__label'>URL</label>
          <Field
            name='url'
            component={renderTextField}
            placeholder='https://themeforest.net'
            type='url'
          />
       </div>*/}
          <div className='form__form-group-field'>
            <Field
              id='password'
              name='password'
              component={render_field}
              placeholder='Password'
              type='password'
            />
          </div>
          <div className='form__form-group-field'>
            <Field
              id='telephone'
              name='telephone'
              component={render_field}
              placeholder={this.props.user.phone_number}
              onChange={this.handleChange('name')}
              type='text'
            />
          </div>

          <ButtonToolbar className='form__button-toolbar'>
            <Button color='primary' type='submit'>Update profile</Button>
            {/* <Button type='button' onClick={reset}>
              Cancel
            </Button> */}
          </ButtonToolbar>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'profile_settings_form', // a unique identifier for this form
})(ProfileSettings);



// WEBPACK FOOTER //
// ./src/components/account/profile/components/ProfileSettings.js